import { render, staticRenderFns } from "./BuildSite.vue?vue&type=template&id=22205a5a&scoped=true"
import script from "./BuildSite.vue?vue&type=script&lang=js"
export * from "./BuildSite.vue?vue&type=script&lang=js"
import style0 from "./BuildSite.vue?vue&type=style&index=0&id=22205a5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22205a5a",
  null
  
)

export default component.exports